/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Representa una fila real en la BD (un log).
 */
export interface LifecycleEvent { 
    stage: string;
    label: string;
    timestamp: string;
    metadata?: object | null;
}

